<template>
	<div class="bodycont">
		 <div class="cont Pub_width">
			 <div class="nav">
				 当前位置：<span @click="goindex()">搜索>&nbsp;</span><span style="color: #005b9f;">{{keyword}}</span>
			 </div>
			 <div class="richtext">
				<div class="nothing">无搜索结果</div>
				<newslist :listdata="data"></newslist>
			 </div>
		 </div>
	</div>
</template>

<script>
	import newslist from '../components/list.vue'
	export default({
		data(){
			return{
				data:[],
				keyword:""
			}
		},
		components:{
			newslist
		},
		methods:{
			loaddetail(){
				let keyword=this.$route.query.keyword
				this.$Get("api.php/cms/search",{keyword},"get").then(res=>{
					this.data=res.data.data
				})
			},
			goindex(){
				this.$router.push({name:"index_page"})
			},
			goback(){
				this.$router.go(-1)
			}
		},
		created() {
			let keyword=this.$route.query.keyword
			this.keyword=keyword
			this.loaddetail()
		}
	})
</script>

<style scoped="scoped">
	.nav{
		background: white;
		margin-top: 20px;
		margin-bottom: 20px;
		border-radius: 5px;
		width: 100%;
		height: 58px;
		background-color: white;
		border-radius: 5px;
		line-height: 58px;
		padding-left: 20px;
		font-size: 14px;
		cursor: default;
	}
	.nav>span:hover{
		    color: #005b9f;
			text-decoration: underline;
	}
	.richtext{
		background: white;
		border-radius: 5px;
		min-height: 500px;
		padding: 20px;
		width: calc(100% - 20px) ;
	}

	.richtitle{
		font-size: 18px;
		display: inline-block;
		width: 100%;
		text-align: center;
		color: #005b9f;
		padding: 10px 0px;
	}
	.richtime{
		font-size: 14px;
		color: #797979;
		padding-top: 10px;
		text-align: center;
	}
	.richdesc{
		color: rgb(16, 11, 205);
		font-size: 13px;
		text-align: center;
		padding: 10px 0px;
	}
	.richtextcont{
		padding: 15px;
	}
	.richtext img{
		max-width: 100%;
	}
	.nothing{
		color: #999;
		text-align: center;
		width: 100%;
		padding-top: 30px;
		font-size: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/view/search.vue